import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectLessons, selectTotal, selectPage, selectLimit } from '../selectors/lessons.selector';
import { lessonsActions } from '../actions/lessons.actions';
import { PaginationParams } from '../types';

@Injectable({
    providedIn: 'root',
})
export class LessonsFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly lessons$ = this.store.select(selectLessons);
    readonly total$ = this.store.select(selectTotal);
    readonly page$ = this.store.select(selectPage);
    readonly limit$ = this.store.select(selectLimit);

    readonly lessons = this.store.selectSignal(selectLessons);
    readonly total = this.store.selectSignal(selectTotal);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly page = this.store.selectSignal(selectPage);
    readonly limit = this.store.selectSignal(selectLimit);

    getLessons(value: PaginationParams): void {
        this.store.dispatch(lessonsActions.getLessons({ value }));
    }

    clear(): void {
        this.store.dispatch(lessonsActions.clear());
    }
}
